import React, {Component} from 'react';

import Label from './label';
import HoverMarker from './hover_marker';
import DisplayMarkerCircle from './display_marker_circle';
import DisplayMarkerSquare from './display_marker_square';
const markerTypes = {
    HoverMarker,
    DisplayMarkerCircle,
    DisplayMarkerSquare
};

import {getMapLabels, getMapMarkers} from './map_helper';

export default class UserDemographicMap extends Component {
    constructor(props) {
        super(props);
        this.start = this.start.bind(this);
        this.handleUserMouseEnter = this.handleUserMouseEnter.bind(this);
        this.handleUserMouseLeave = this.handleUserMouseLeave.bind(this);
        this.displayMapLabels = this.displayMapLabels.bind(this);
        this.displayMapMarkers = this.displayMapMarkers.bind(this);
        this.selectUser = this.selectUser.bind(this);
        this.state = {
            selectedUserIndex: 1,
            isAutomated: true,
            xOffset: 0
        };
    }

    componentWillUnmount() {
        if (this.state.isAutomated && this.interval) {
            clearInterval(this.interval);
        }
    }

    start() {
        if (this.interval) return;

        const {isAutomated} = this.state;
        const {renderingComponent, pageWidth, interval} = this.props;
        const users = getMapMarkers(renderingComponent, pageWidth);

        if (!users) return null;

        this.interval = setInterval(() => {
            if (isAutomated) {
                let nextIndex = this.state.selectedUserIndex + 1;
                if (nextIndex === users.length) nextIndex = 0;
                this.selectUser(nextIndex);
            }
        }, interval);
    }

    handleUserMouseEnter(i){
        this.selectUser(i, false);
    }

    handleUserMouseLeave(){
        this.setState({
            isAutomated: true
        });
    }

    displayMapLabels(){
        const {renderingComponent, pageWidth} = this.props;
        const labels = getMapLabels(renderingComponent, pageWidth);

        if (!labels) return null;

        return labels.map((label, idx) => {
            return <Label key={idx} label={label} />
        });
    }

    displayMapMarkers() {
        const {selectedUserIndex} = this.state;
        const {renderingComponent, pageWidth, markerType} = this.props;
        const markerInfo = getMapMarkers(renderingComponent, pageWidth);
        const MarkerType = markerTypes[markerType];

        if (!markerInfo) return null;

        return markerInfo.map((user, idx) => {
            const isSelected = selectedUserIndex === idx ? true : false;

            return (
                <MarkerType
                    key={idx}
                    user={user}
                    isSelected={isSelected}
                    handleUserMouseEnter={this.handleUserMouseEnter.bind(this, idx)}
                    handleUserMouseLeave={this.handleUserMouseLeave} />
            );
        });
    }

    selectUser(selectedUserIndex, isAutomated = true) {
        const {renderingComponent, pageWidth} = this.props;
        const users = getMapMarkers(renderingComponent, pageWidth);
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (!users) return null;

        let xOffset = 0;

        if (width < 1440) {
            const userX = users[selectedUserIndex].pos_x;
            xOffset = (720 - userX);
        }

        this.setState({
            selectedUserIndex,
            isAutomated,
            xOffset
        });
    }

    render() {
        const labels = this.displayMapLabels();
        const mapMarkers = this.displayMapMarkers();

        return (
            <div className="user-demographic-map">
                {labels}
                {mapMarkers}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/user_demographic_map/index.js